import { render } from "./billItems.vue?vue&type=template&id=c03652ae"
import script from "./billItems.vue?vue&type=script&lang=js"
export * from "./billItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__